import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'warning-dialog',
    templateUrl: './warning-dialog.component.html',
    styleUrls: ['./warning-dialog.component.scss'],
    standalone: false
})
export class WarningDialogComponent implements OnInit {
    @Input() public items: any[] = [];
    @Input() public isDiallerCheck: boolean = false;

    public filteredItems: string = "";

    constructor(
        public dialogRef: MatDialogRef<WarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.items = this.data.items;
        this.isDiallerCheck = this.data.isDiallerCheck;
        if (this.data.isDiallerCheck) {
            this.filteredItems = this.items.map(i => i["name"]).join(', ');
        } else {
            this.filteredItems = this.items.map(i => i["description"]).join(', ');
        }
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}